//
//
//
//
//
//
//
//
//
//

export default {
  name: 'appMain',
  computed: {
    // cachedViews() {
    //   return this.$store.state.tagsView.cachedViews
    // },
    key () {
      if (this.$route.matched.length === 2) {
        return this.$route.fullPath
      }
    }
  }

}



// WEBPACK FOOTER //
// ./src/views/layout/components/AppMain.vue